import jwt_decode from 'jwt-decode';
import dayjs from './dayjs.util';

import LocalStorageService from '../services/local-storage.service';
import CaipirinhaRequest from '../requests/caipirinha-api/caipirinha.request';

interface Payload {
  id: string;
  document: string;
}

interface JwtPayload {
  exp: number;
};

const generateToken = async (order: Payload) => {
  const response = await CaipirinhaRequest.authCustomer(
    order.id,
    order.document,
  );
  if (response) {
    LocalStorageService.setItem('token', response);
    return response;
  }
  return null;
};

const getTokenCached = () => {
  const cache = LocalStorageService.getItem<string>('token');
  if (cache) {
    const token = jwt_decode<JwtPayload>(cache);
    const createdAt = dayjs(token.exp * 1000);

    if (createdAt.diff() > 0) {
      return cache;
    }
  }
  return null;
};

export const getToken = async () => {
  const order = LocalStorageService.getItem<Payload>('order');
  if (order) {
    const cache = getTokenCached();
    if (cache) {
      return cache;
    }
    return await generateToken(order);
  }
  return null;
};
